import { useState } from 'react'

const useRowSelect = () => {
  const [selected, setSelected] = useState<string[]>([])

  function onSelect(checked: boolean, id: string) {
    if (checked) {
      setSelected(prev => [...prev, id])
    } else {
      setSelected(prev => prev.filter(x => x !== id))
    }
  }

  function onSelectAll(rows: string[], checked: boolean) {
    if (checked) {
      setSelected(rows)
    } else {
      setSelected([])
    }
  }
  return { selected, onSelect, onSelectAll }
}

export default useRowSelect
